import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { ScalePollResultTask } from "../../taskbook.types";
import { PollResultService } from "../../../timeline/timeline-item/poll-result/poll-result.service";
import { TranslateService } from "@ngx-translate/core";
import { PollResultValue } from "../../../timeline/timeline-item/poll-result/poll-result.type";

@Component({
    selector: 'scale-poll-result-task',
    templateUrl: './scale-poll-result-task.component.html',
    styleUrls: ['./../task.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ScalePollResultTaskComponent {

    protected participationCount: number;
    protected tabIndexToShow: number = 0;
    protected resultsTabLabel: string;
    protected trendsTabLabel: string;
    protected orderedValues: PollResultValue[];
    
    @Input() task: ScalePollResultTask
    @Output() onComment = new EventEmitter()
    @Output() onReported = new EventEmitter()

    constructor(
        private translateService: TranslateService,
        private pollResultService: PollResultService
    ) {
        this.resultsTabLabel = this.translateService.instant('poll_results.results')
        this.trendsTabLabel = this.translateService.instant('poll_results.trends')
    }

    ngOnInit() {
        this.participationCount = this.pollResultService.getParticipationCount(this.task.results.values)
        this.orderedValues = this.task.results.values.sort((a, b) => b.position - a.position)
    }

    onTabChanged(event){
        this.tabIndexToShow = event.index;
    }

    comment(){
        this.onComment.emit('');
    }

    achive(){
        this.task = undefined
    }

    reportItem(){
        this.onReported.emit();    
    }
    
}